import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess107122Status: 'idle',
    startProcess107122Error: undefined as any,
    loadUserParamsProcess107122Status: 'idle',
    loadUserParamsProcess107122Error: undefined as any,

    process107122List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess107122 = createAsyncThunk('process107122Slice/startProcess107122', async ({ process107122 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess107122/`,
        prepareData(process107122),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess107122Status } = getState().process107122Slice
        return startProcess107122Status !== 'pending'
    }
})

export const loadUserParamsProcess107122 = createAsyncThunk('process107122Slice/loadUserParamsProcess107122', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess107122/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess107122Status } = getState().process107122Slice
        return loadUserParamsProcess107122Status !== 'pending'
    }
})

const Process107122Slice = createSlice({
    name: 'process107122Slice',
    initialState,
    reducers: {
        resetstartProcess107122: (state) => {
            state.job = undefined
            state.startProcess107122Error = undefined
        },
        resetstartProcess107122Error: (state) => {
            state.startProcess107122Error = undefined
        },
        resetloadUserParamsProcess107122: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess107122Error = undefined
        },
        resetloadUserParamsProcess107122Error: (state) => {
            state.loadUserParamsProcess107122Error = undefined
        },
        removeFromProcess107122ListById: (state, action) => {
            state.process107122List = state.process107122List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess107122ListByIds: (state, action) => {
            state.process107122List = state.process107122List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process107122List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess107122Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process107122List = []
            state.startProcess107122Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess107122.pending, (state) => {
            state.startProcess107122Status = 'pending'
            state.startProcess107122Error = undefined
        })
        builder.addCase(startProcess107122.fulfilled, (state, action) => {
            state.startProcess107122Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.job = newItem
            }
        })
        builder.addCase(startProcess107122.rejected, (state, action) => {
            state.startProcess107122Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess107122Error = action.error.message
            } else {
                state.startProcess107122Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess107122.pending, (state) => {
            state.loadUserParamsProcess107122Status = 'pending'
            state.loadUserParamsProcess107122Error = undefined
        })
        builder.addCase(loadUserParamsProcess107122.fulfilled, (state, action) => {
            state.loadUserParamsProcess107122Status = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.defaultValues = newItem
            }
        })
        builder.addCase(loadUserParamsProcess107122.rejected, (state, action) => {
            state.loadUserParamsProcess107122Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess107122Error = action.error.message
            } else {
                state.loadUserParamsProcess107122Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess107122,
    resetstartProcess107122Error,
    resetloadUserParamsProcess107122,
    resetloadUserParamsProcess107122Error,
    removeFromProcess107122ListById,
    removeFromProcess107122ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process107122Slice.actions
export default Process107122Slice.reducer
